import { render, staticRenderFns } from "./m-related-products.vue?vue&type=template&id=8d495470&"
import script from "./m-related-products.vue?vue&type=script&lang=js&"
export * from "./m-related-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports